import {ROUTES} from '../../../config/index.js'

export async function getInitialProps({context: {domain}, routeInfo: {location}}) {
  const {
    query: {adId, tradeId}
  } = location

  const config = domain.get('config')
  const {AlreadyCancelledTradeTransactionsError} = config.get('COMMON').ERRORS
  const {TRANSACTION_BUYER_PRICE_NEGOTIATION_START_PAGE_NAME} = config.get('page')

  const [adDetailsError, adDetailsResponse] = await domain.get('get_ad_details_ads_use_case').execute({adId})

  if (adDetailsError) {
    return {
      __HTTP__: {
        redirectTo: '/'
      }
    }
  }

  const [getTradeDataError, getTradeDataResponse] = await domain
    .get('get_trade_data_transactions_use_case')
    .execute({tradeId})

  if (getTradeDataError instanceof AlreadyCancelledTradeTransactionsError) {
    return {
      __HTTP__: {
        redirectTo: ROUTES.USER.MESSAGES
      }
    }
  }

  const agreedPrice = getTradeDataError ? `` : getTradeDataResponse.agreedPrice
  const sellerName = getTradeDataError ? `` : getTradeDataResponse.sellerName

  const getTrackingData = async () => {
    return domain.get('get_page_tracking_data_use_case').execute({
      page: TRANSACTION_BUYER_PRICE_NEGOTIATION_START_PAGE_NAME
    })
  }

  const pageTrackingData = await getTrackingData()

  return {
    adId: adDetailsResponse.ad?.id,
    adPrice: adDetailsResponse.ad?.price,
    adTitle: adDetailsResponse.ad?.title,
    agreedPrice,
    buyerId: getTradeDataResponse?.buyerId,
    pageTrackingData,
    sellerId: getTradeDataResponse?.sellerId,
    sellerName
  }
}
